(function () {
  'use strict';

  angular.module('ringbaPortal').component('publishedOfferBox', {
    bindings: {
      campaignId: '<',
      publishedOffer: '<',
      hasDraft: '<',
      onOfferExpire: '&',
      onCampaignOfferChange: '&',
      editPublishedOffer: '&',
      reloadCampaign: '&'
    },
    controller: PublishedOfferBoxController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/published-offer-box/published-offer-box.view.html'
  });

  function PublishedOfferBoxController(
    $scope,
    $state,
    $translate,
    $uibModal,
    accountsService,
    dateTimeService,
    moment,
    offersService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.pauseOfferConfirm = pauseOfferConfirm;
    vm.pauseOffer = pauseOffer;
    vm.resumeOfferConfirm = resumeOfferConfirm;
    vm.resumeOffer = resumeOffer;
    vm.deleteOfferConfirm = deleteOfferConfirm;
    vm.deleteOffer = deleteOffer;
    vm.leaveOfferConfirm = leaveOfferConfirm;
    vm.leaveOffer = leaveOffer;
    vm.onExpire = onExpire;
    vm.cancelModal = cancelModal;

    function onInit() {
      vm.isAffiliate = accountsService.isAffiliate();
    }

    function onChanges() {
      _setExpirationFields();
    }

    function pauseOfferConfirm() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/pause-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function pauseOffer() {
      return offersService.pausePublishedOffer(accountsService.currentAccountId, vm.campaignId).then(function () {
        toaster.pop('success', $translate.instant('OFFER_PAUSE_SUCCESS'));
        vm.onCampaignOfferChange();
        cancelModal();
      }).catch(utils.errorHandler);
    }

    function resumeOfferConfirm() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/resume-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function resumeOffer() {
      return offersService.resumePublishedOffer(accountsService.currentAccountId, vm.campaignId).then(function () {
        toaster.pop('success', $translate.instant('OFFER_RESUME_SUCCESS'));
        vm.onCampaignOfferChange();
        cancelModal();
      }).catch(utils.errorHandler);
    }

    function deleteOfferConfirm() {
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/delete-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function deleteOffer() {
      return offersService.deletePublishedOffer(accountsService.currentAccountId, vm.campaignId, vm.keepNumbers).then(function () {
        toaster.pop('success', $translate.instant('OFFER_DELETE_SUCCESS'));
        vm.onCampaignOfferChange();
        vm.reloadCampaign();
        cancelModal();
      }).catch(utils.errorHandler);
    }

    function leaveOfferConfirm() {
      vm.leaveOfferModalTitle = $translate.instant('CONFIRM_LEAVE_MODAL_TITLE', { offerName: vm.publishedOffer.name });
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/components/offer/leave-offer-confirmation.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function leaveOffer() {
      return offersService.leaveCampaignOffer(accountsService.currentAccountId, vm.campaignId, vm.leaveMessage).then(function () {
        toaster.pop('success', $translate.instant('OFFER_LEAVE_SUCCESS'));
        $state.go('dashboard.campaigns');
      }).catch(utils.errorHandler);
    }

    function onExpire() {
      _setExpirationFields();
      vm.onOfferExpire();
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function _setExpirationFields() {
      const expirationTime = vm.publishedOffer && vm.publishedOffer.expiration ? moment(vm.publishedOffer.expiration) : null;
      if (expirationTime) {
        vm.expiration = expirationTime.format('MMM D YYYY, hh:mm A');
        vm.offerExpired = dateTimeService.getCurrentMomentInTimeZone(vm.publishedOffer.timeZoneId).isAfter(expirationTime);
        if (vm.offerExpired) {
          vm.publishedOffer.offerState = 'expired';
          vm.offerHeaderExpirationLabel = $translate.instant('OFFER_EXPIRED_HEADER_LABEL');
          vm.onOfferExpire();
        } else {
          vm.offerHeaderExpirationLabel = $translate.instant('OFFER_EXPIRATION_HEADER_LABEL');
        }
      } else {
        _resetExpirationFields();
      }
    }

    function _resetExpirationFields() {
      vm.expiration = null;
      vm.offerExpired = null;
      vm.offerHeaderExpirationLabel = null;
    }

  }
})();
